<template>
  <svg
    :class="props.customClass"
    viewBox="0 0 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      :fill="props.fillColor"
      d="M5.88866 7.83686L0.5 13.1163L2.39181 14.8281L9.5 7.83686L2.39181 0.828124L0.499999 2.53995L5.88866 7.83686Z"
    />
  </svg>
</template>

<script setup>
const props = defineProps({
  customClass: {
    type: String,
    default: "w-2.5 h-4",
  },
  fillColor: {
    type: String,
    default: "#007F80",
  },
});
</script>
